import React from 'react'
import Select from 'react-select'
import { SelectV2Props } from './types'
import colourStyles from './styles'
import { get, useFormContext } from 'react-hook-form'
import { Controller } from 'react-hook-form'

const SelectField = ({ options, placeholder, name, isSearchable = true }: SelectV2Props) => {
    const {
        formState: { errors },
        control,
    } = useFormContext()
    const error = get(errors, name)

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value } }) => (
                <>
                    <Select
                        value={value}
                        isSearchable={isSearchable}
                        options={options}
                        styles={colourStyles}
                        placeholder={placeholder}
                        className={error && '[&>div:first-of-type]:border-brand-red'}
                        onChange={onChange}
                    />
                    {error && <p className="error text-brand-red pt-1">{error?.message || error?.value?.message}</p>}
                </>
            )}
        />
    )
}

export default SelectField
